import { render, staticRenderFns } from "./ChildInfoRow.vue?vue&type=template&id=ce22b0f0&scoped=true"
import script from "./ChildInfoRow.vue?vue&type=script&lang=js"
export * from "./ChildInfoRow.vue?vue&type=script&lang=js"
import style0 from "./ChildInfoRow.vue?vue&type=style&index=0&id=ce22b0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce22b0f0",
  null
  
)

export default component.exports